export const HEADLINE_LEVELS = {
  first: 'first',
  second: 'second',
  third: 'third',
} as const
